import React, { useState } from 'react';
import ActionButton from '../../ActionButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';
import { Colors } from 'library';
import client from 'shared/ApiClient';
import ProviderSelection from './ProviderSelection';
import { IShareableProvider } from './models';
import IProvider from '../../../../../../models/Providers/IProvider';
import { track } from 'shared';

export default function ShareProviderAction({ setProvider }: { setProvider: (x: IProvider) => void }) {
    const [showProviderSelection, setShowProviderSelection] = useState(false);

    const onCloseDialog = () => {
        setShowProviderSelection(false);
    };

    const handleProviderSelection = (provider: IShareableProvider) => {
        client(`shareable-provider-info/${provider.id}/`).then((response) => {
            setProvider(response[0]);
        });
        track('Newsfeed: Selected a provider to share', {
            shared_provider_id: provider.id,
            shared_provider_name: `${provider.name}`,
        });
    };

    return (
        <div>
            <ActionButton
                icon={() => (
                    <FontAwesomeIcon
                        icon={faUserTag}
                        color={Colors.darkNavy}
                        size={'sm'}
                        onClick={() => setShowProviderSelection(true)}
                    />
                )}
            />
            <ProviderSelection
                open={showProviderSelection}
                onClose={onCloseDialog}
                selectProvider={(e: any) => handleProviderSelection(e)}
            />
        </div>
    );
}
